import * as React from 'react';
import { RouteObject } from 'react-router-dom';

// User Containers
const AdminUsers = React.lazy(() => import(/* webpackChunkName: "admin-users" */ '../../../../containers/Admin/Users'));
const User = React.lazy(
    () => import(/* webpackChunkName: "admin-users-user" */ '../../../../containers/Admin/Users/children/User')
);
const UsersTable = React.lazy(
    () => import(/* webpackChunkName: "admin-users-table" */ '../../../../containers/Admin/Users/children/UsersTable')
);

export const AdminUserRoutes: RouteObject = {
    path: 'users',
    element: (
        <React.Suspense fallback={<>...</>}>
            <AdminUsers />
        </React.Suspense>
    ),
    children: [
        {
            index: true,
            element: (
                <React.Suspense fallback={<>...</>}>
                    <UsersTable />
                </React.Suspense>
            )
        },
        {
            path: 'user/:userId',
            element: (
                <React.Suspense fallback={<>...</>}>
                    <User />
                </React.Suspense>
            )
        }
    ]
};
